import { numberValue } from './pricing.js';

export function normalizeCatalogValue(value) {
  return String(value || '').trim().toLocaleLowerCase().replace(/\s+/g, ' ');
}

export function catalogIdentityFields(product = {}) {
  return {
    normalizedName: normalizeCatalogValue(product.name),
    normalizedSku: normalizeCatalogValue(product.sku),
  };
}

export function findCatalogDuplicate(products = [], candidate = {}, currentProductId = '') {
  const candidateIdentity = catalogIdentityFields(candidate);
  return products.find((product) => {
    if (currentProductId && String(product.id || '') === String(currentProductId)) return false;
    const productIdentity = {
      normalizedName: product.normalizedName || normalizeCatalogValue(product.name),
      normalizedSku: product.normalizedSku || normalizeCatalogValue(product.sku),
    };
    return Boolean(
      (candidateIdentity.normalizedName && productIdentity.normalizedName === candidateIdentity.normalizedName)
      || (candidateIdentity.normalizedSku && productIdentity.normalizedSku === candidateIdentity.normalizedSku)
    );
  }) || null;
}

export function matchesCatalogSearch(product = {}, query = '') {
  const needle = normalizeCatalogValue(query);
  if (!needle) return true;
  return [product.name, product.sku, product.category, product.profileName, product.notes]
    .some((value) => normalizeCatalogValue(value).includes(needle));
}

export function uniqueCatalogCopyName(products = [], originalName = 'Product') {
  const baseName = `${String(originalName || 'Product').trim() || 'Product'} Copy`;
  if (!findCatalogDuplicate(products, { name: baseName })) return baseName;
  let sequence = 2;
  while (findCatalogDuplicate(products, { name: `${baseName} ${sequence}` })) sequence += 1;
  return `${baseName} ${sequence}`;
}

export function catalogProductIdForEstimate(estimateId) {
  const normalized = String(estimateId || '').trim().replaceAll('/', '-');
  if (!normalized) throw new Error('A saved estimate ID is required before adding it to the catalog.');
  return `estimate-${normalized}`;
}

export function catalogProductFromEstimate(estimate = {}) {
  const inputs = estimate.inputs || {};
  return {
    name: String(estimate.name || 'Untitled estimate').trim() || 'Untitled estimate',
    profileId: String(estimate.profileId || ''),
    profileName: String(estimate.profileName || estimate.profileSnapshot?.name || 'Saved cost profile'),
    filamentGrams: Math.max(0, numberValue(inputs.filamentGrams)),
    printHours: Math.max(0, numberValue(inputs.printHours)),
    printMinutes: Math.min(59, Math.max(0, numberValue(inputs.printMinutes))),
    quantity: Math.max(1, Math.floor(numberValue(inputs.quantity, 1))),
    averagePowerWatts: Math.max(0, numberValue(inputs.averagePowerWatts)),
    laborMinutes: Math.max(0, numberValue(inputs.laborMinutes)),
    additionalCost: Math.max(0, numberValue(inputs.additionalCost)),
    targetMargin: Math.min(94.99, Math.max(0, numberValue(inputs.targetMargin, numberValue(estimate.results?.targetMargin)))),
    sourceEstimateId: String(estimate.id || ''),
  };
}
